import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditorJS from '@editorjs/editorjs';

import VideoInstructionModal from './VideoInstructionModal';
import { addInstructionEventByEditor } from '../utils';
import { InstructionEvent } from '../types';
import {
  setVideoInstructionId,
  setOpenVideoInstructionModal,
  setInlineVideoInstruction,
} from '../../../../store/modules/script-editor/actions';
import { selectVideoInstruction } from '../../../../store/modules/script-editor/selectors';
import { addEventListenerToVideoActions } from './utils';
import {Formik} from "formik";

type Props = {
  instanceEditor: EditorJS | undefined;
  refEditor: HTMLDivElement | null;
};

const VideoInstructionComponent = ({ instanceEditor, refEditor }: Props) => {
  const dispatch = useDispatch();
  const { isOpenModal } = useSelector(selectVideoInstruction);

  useEffect(() => {
    if (instanceEditor) {
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.OPEN_VIDEO_INSTRUCTION_MODAL,
        (data) => {
          dispatch(setOpenVideoInstructionModal(true));
          dispatch(setVideoInstructionId(data.instructionId));
          dispatch(setInlineVideoInstruction(data.isInline));
        },
      );
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.UPDATE_VIDEO_ACTION_EVENT_LISTENERS,
        // eslint-disable-next-line
        ({ refEditor, instanceEditor }) => {
          addEventListenerToVideoActions({ instanceEditor, refEditor });
        },
      );
    }
  }, [dispatch, instanceEditor]);

  useEffect(() => {
    if (instanceEditor && refEditor) {
      addEventListenerToVideoActions({ instanceEditor, refEditor });
    }
  }, [instanceEditor, refEditor]);

  if (!isOpenModal) {
    return null;
  }

  return (
    <Formik initialValues={{video: ''}} onSubmit={()=>{}}>
      <VideoInstructionModal instanceEditor={instanceEditor} />
    </Formik>
  );
};

export default VideoInstructionComponent;
